module.exports = __webpack_public_path__ + "img/top4.089826b0.png";